import { Form, Link, redirect, type ActionFunction } from "react-router";
import { FormRow, Logo, RegisterAndLoginPageWrapper, SubmitBtn } from "../components";

import { httpSuccessToast } from "@/utils";
import { Api, Types } from "@/services";

export const registerAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData();
  const payload = Object.fromEntries(formData) as unknown as Types.Request.Register;

  const resp = await Api.Register(payload);
  httpSuccessToast(resp, "Registration successful");
  return redirect("/login");
};

const Register = () => {
  return (
    <RegisterAndLoginPageWrapper>
      <Form className="form" method="POST">
        <Logo />
        <h4>Register</h4>

        {/* form rows */}
        <FormRow name="name" />
        <FormRow name="lastName" labelText="last name" />
        <FormRow name="location" />
        <FormRow type="email" name="email" />
        <FormRow type="password" name="password" />
        <SubmitBtn formBtn />

        <p>
          Already a member?{" "}
          <Link className="member-btn" to="/login">
            Login
          </Link>
        </p>
      </Form>
    </RegisterAndLoginPageWrapper>
  );
};
export default Register;
